import { useEffect } from 'react';

const useAutoScrollOnLoad = ({ autoScroll, sending, loading, scrollToBottom }) => {
  useEffect(() => {
    if (!autoScroll) {
      return;
    }

    if (!sending && !loading) {
      scrollToBottom();
    }
  }, [autoScroll, sending, loading, scrollToBottom]);
};

export default useAutoScrollOnLoad;
